import IProject from "@/modules/ProjectManager/ts/IProject";
import IFilter from "@/modules/PanelistManager/ts/IFilter";
import {GetterTree} from "vuex";

export const getters: GetterTree<any, any> = {

    /**
     * Get projects filtered by status
     */
    getFilteredProjects: (state: { activeTableFilters: IFilter[]; projects: any; prominentProject: { id: number; }; }, getters: any, rootState: { user: { id: number; }; }) => {

        let activeFilters: Array<IFilter> = [];

        state.activeTableFilters.forEach((filter: IFilter) => {
            if (filter.model) activeFilters.push(filter);
        });

        let projects: Array<IProject> = JSON.parse(JSON.stringify(state.projects));

        // Remove highlighted project from the list
        if (state.prominentProject && state.prominentProject.id) {
            projects = projects.filter((project: IProject) => project.id !== state.prominentProject.id);
        }

        if (activeFilters.length === 0) return projects;

        activeFilters.forEach((filter: IFilter) => {

            // Mine filter
            if (filter.type === "mine") {
                projects = projects.filter((project: IProject) => {
                    return project.created_by.id === rootState.user.id;
                });
            }

            // Responsible filter
            if (filter.type === "responsible") {
                projects = projects.filter((project: IProject) => {
                    return project.created_by.id === rootState.user.id ||
                        (project.assistant_manager && project.assistant_manager.id === rootState.user.id);
                });
            }

            // Others filter
            if (filter.type === "others") {
                projects = projects.filter((project: IProject) => {
                    return project.created_by.id !== rootState.user.id;
                });
            }

            // Status filter
            if (filter.type === "online") {
                projects = projects.filter((project: IProject) => {
                    return project.status === "online";
                });
            }

            // Status filter
            if (filter.type === "offline") {
                projects = projects.filter((project: IProject) => {
                    return project.status === "offline";
                });
            }

            // Status filter
            if (filter.type === "paused") {
                projects = projects.filter((project: IProject) => {
                    return project.status === "paused";
                });
            }

            // Status filter
            if (filter.type === "closed") {
                projects = projects.filter((project: IProject) => {
                    return project.status === "closed";
                });
            }

            // Managed by user
            if (filter.type === "user-managed") {
                projects = projects.filter((project: IProject) => {
                    return filter.ids.includes(project.created_by.id);
                });
            }

            // Responsible by user
            if (filter.type === "user-responsible") {
                projects = projects.filter((project: IProject) => {
                    return filter.ids.includes(project.created_by.id) ||
                        (project.assistant_manager && filter.ids.includes(project.assistant_manager.id));
                });
            }
        });

        let filterSubPanelIds: Array<number> = [];

        activeFilters.filter((filter: IFilter) => filter.type.includes("sub-panel"))
            .forEach((filter: IFilter) => {
                filterSubPanelIds = [...filterSubPanelIds, ...filter.ids]
            });

        if (filterSubPanelIds.length > 0) {

            projects = projects.filter((project: IProject) => {

                const projectSubPanelIds = project.sub_panels.map(s => s.id);

                return filterSubPanelIds.filter(x => projectSubPanelIds.includes(x)).length > 0;
            })
        }

        return projects;
    },

    /**
     * Find project from loaded projects
     */
    findProject: (state: { projects: any[]; }) => (id: number) => {

        return state.projects.find((project: IProject) => {
            return project.id === id;
        });
    },

    findArchivedProject: (state: { archivedProjects: any[]; }) => (id: number) => {

        return state.archivedProjects.find((project: IProject) => {
            return project.id === id;
        });
    }
}
